// extracted by mini-css-extract-plugin
export default {"container":"inputbox_container__slM5-","input":"inputbox_input__sOY4A","clear":"inputbox_clear__KWFqW"};